/* roles.js */

"use strict";
/* global Slick */
const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const {
    Control: {
        Action: {Button},
    },
} = uiCore;

const formatters = require("../../../cellFormaters");
const mapDataFormatters = require("../../../cellFormaters/mapDataFormatters");
const checkBoxEditor = require("../../../cellEditors/CheckBoxEditor");
const vendorEditor = require("../../../cellEditors/MapData/VendorEditor");
const deviceTypeEditor = require("../../../cellEditors/MapData/DeviceTypeEditor");
const netBoxDeviceRoleEditor = require("../../../cellEditors/MapData/NetBoxDeviceRoleEditor");

const getDefaultCreateValue = require("../../../cellEditors/MapData/mapDataUtil");

// function createWithContext(ctx) {
//     const functions = [
//         _createRolesContent,
//         _getRolesGridData,
//         _getRoleRow,
//         _formatRoleData,
//         _formatRoleGridToMapping,
//         _setRoleData,
//         _setRoleDataToEty,
//         registerRoleListeners,
//         unregisterRoleListeners,
//         _resetRoleGrid,
//         _resetRoleGridView,
//         _onAddNewRole,
//         _deleteRole,
//         _renderRolesSlickGrid,
//     ];

//     const exportObj = {};
//     functions.forEach(fun => {
//         exportObj[fun] = fun.bind(ctx);
//     });
//     return exportObj;
// }

// module.exports = {
//     createWithContext
// };

function createWithContext(context) {
    let ctx = context;
    ctx._isRoleDataValid = false;
    ctx._createRolesContent = function () {
        const slickTableRolesContainerMain = document.createElement("slick-table-cmdb-container");
        ctx._slickTableRolesContainer = document.createElement("slick-table-cmdb");
        ctx._addNewRulesRowButton = new Button({
            label: "Add Device Role +",
            active: true,
        });

        slickTableRolesContainerMain.appendChild(ctx._slickTableRolesContainer);

        const addRowButtonContainer = document.createElement("div");
        addRowButtonContainer.classList.add("add-new-rule-container");
        addRowButtonContainer.appendChild(ctx._addNewRulesRowButton._renderer._rootElem);
        slickTableRolesContainerMain.appendChild(addRowButtonContainer);

        ctx._slickRolesTable = undefined;
        ctx._maxSortOrderRoles = 0;

        ctx._columnsDeviceRole = [
            {
                id: "vendor",
                field: "vendor",
                width: 300,
                name: "Gluware Vendor",
                tooltip: "Gluware Vendor",
                resizable: false,
                formatter: mapDataFormatters.vendorFormatter,
                editor: vendorEditor,
            },
            {
                id: "deviceType",
                field: "deviceType",
                width: 316,
                name: "Gluware Device Type",
                tooltip: "Gluware Device Type",
                resizable: false,
                formatter: mapDataFormatters.deviceTypeFormatter,
                editor: deviceTypeEditor,
            },
            {
                id: "create",
                field: "create",
                width: 90,
                name: "Create",
                tooltip: "Create",
                resizable: false,
                headerCssClass: "centered",
                formatter: formatters.checkboxFormatter,
                editor: checkBoxEditor,
            },
            {
                id: "netBoxDeviceRole",
                field: "netBoxDeviceRole",
                width: 350,
                name: "NetBox Device Role",
                tooltip: "NetBox Device Role",
                resizable: false,
                formatter: mapDataFormatters.netboxRoleFormatter,
                editor: netBoxDeviceRoleEditor,
            },
            {
                id: "deleteRow",
                width: 90,
                name: "Action",
                field: "deleteRow",
                selectable: false,
                resizable: false,
                cssClass: "cell-delete dnd centered",
                formatter: mapDataFormatters.deleteButtonFormatter,
                headerCssClass: "centered",
            },
        ];

        ctx._deviceRoleContainer.appendChild(slickTableRolesContainerMain);
        ctx._deviceRoleContainer.appendChild(
            ctx._drCreateUnmappedCheckbox.renderer.getRootElement()
        );
    };

    ctx.registerRoleListeners = function () {
        ctx._addNewRulesRowButton.on(
            "UserClick",
            (ctx._onAddNewRole = ctx._onAddNewRole.bind(ctx))
        );
    };
    ctx.unregisterRoleListeners = function () {
        ctx._addNewRulesRowButton.removeAllListeners();
        ctx._unregisterRolesSlickTableListeners();
    };

    ctx._registerRolesSlickTableListeners = function () {
        if (ctx._slickRolesTable) {
            ctx._slickRolesTable.onCellChange.subscribe(ctx._onRoleCellChangeAction);
        }
    };

    ctx._unregisterRolesSlickTableListeners = function () {
        if (ctx._slickRolesTable) {
            ctx._slickRolesTable.onCellChange.unsubscribe(ctx._onRoleCellChangeAction);
        }
    };

    ctx._resetRoleGrid = function (data) {
        if (!data) {
            data = ctx._getRolesGridData();
        }
        if (ctx._slickRolesDataView) {
            ctx._slickRolesDataView.setItems(data);
        }
        ctx._resetRoleGridView(data);
    };

    ctx._resetRoleGridView = function (data) {
        ctx._toggleNoDataPlaceholder(!data.length, ctx._slickTableRolesContainer);
        ctx._enableDisableAutoCreate(!data.length, ctx._drCreateUnmappedCheckbox);
        // ctx._sortTable();
        if (ctx._slickRolesTable) {
            ctx._slickRolesTable.invalidate();
            ctx._slickRolesTable.render();
            ctx._slickRolesTable.resizeCanvas();
        }
    };

    ctx._renderRolesSlickGrid = function (data) {
        const roleData = data || ctx._getRolesGridData() || [];
        if (!ctx._slickRolesTable) {
            ctx._slickTableRolesContainer.style.height = (roleData.length + 1) * 80 + "px";
            ctx._slickRolesDataView = new Slick.Data.DataView();
            ctx._slickRolesDataView.setItems(roleData);
            ctx._slickRolesTable = new Slick.Grid(
                ctx._slickTableRolesContainer,
                ctx._slickRolesDataView,
                ctx._columnsDeviceRole,
                ctx._tableOptions
            );

            ctx._registerRolesSlickTableListeners();
            // ctx._slickRolesTable.maxSortOrder = ctx._maxSortOrder;
            ctx._slickRolesTable.setSelectionModel(new Slick.RowSelectionModel());
            // ctx._registerRowMovePlugin(ctx._slickRolesTable, ctx._slickRolesDataView);

            ctx._slickTableRolesContainer.appendChild(ctx._createNoDataPlaceholder());
            ctx._toggleNoDataPlaceholder(!roleData.length, ctx._slickTableRolesContainer);
            ctx._enableDisableAutoCreate(!roleData.length, ctx._drCreateUnmappedCheckbox);
            ctx.registerRoleListeners();

            ctx._slickTableRolesContainer.style.height = "auto";
        } else {
            // ctx._resetRolesData(ctx._model._selectedClass);
            ctx._resetRoleGrid();
        }
    };

    ctx._getRolesGridData = function () {
        const data = ctx._formatRoleData(ctx.getRoleMapping()) || [];
        return data.map((item) => ctx._getRoleRow(item));
    };

    ctx._getRoleRow = function (item) {
        const metaData = ctx._metaData;
        const vendorOptions = ctx._vendorOptions;
        const deviceTypeOptions = ctx._gluDeviceTypeOptions;
        const nbRoleOptions = ctx._nbDeviceRoleOptions;
        const defaultVendor = vendorOptions[0] && vendorOptions[0].value;
        const defaultType = deviceTypeOptions[0] && deviceTypeOptions[0].value;
        const defaultNbRole = nbRoleOptions[0] && nbRoleOptions[0].value;
        let defaultNetBoxName =
            (vendorOptions[0] && vendorOptions[0].label) +
            " - " +
            (deviceTypeOptions[0] && deviceTypeOptions[0].label);
        if (!item) {
            return {
                id: parseInt(Math.random() * 10000, 10),
                vendor: defaultVendor,
                deviceType: defaultType,
                create: false,
                netBoxDeviceRole: defaultNbRole,
                netBoxId: defaultNbRole,
                netBoxName: defaultNetBoxName,
                metaData,
                vendorOptions,
                deviceTypeOptions,
                nbRoleOptions,
            };
        }

        defaultNetBoxName = getDefaultCreateValue(
            item.vendor,
            item.deviceType,
            vendorOptions,
            deviceTypeOptions
        );

        return {
            id: item.id,
            vendor: item.vendor,
            deviceType: item.deviceType,
            create: item.createMissing,
            netBoxDeviceRole: item.netBoxId || item.netBoxName,
            netBoxId: item.netBoxId,
            netBoxName: item.netBoxName || defaultNetBoxName,
            metaData,
            vendorOptions,
            deviceTypeOptions,
            nbRoleOptions,
        };
    };

    ctx._formatRoleData = function (data) {
        if (!data) {
            return false;
        }
        const vendors = Object.keys(data);
        const roleData = [];
        vendors.forEach((vendor, vidx) => {
            const types = Object.keys(data[vendor]);
            types.forEach((type, tidx) => {
                const item = data[vendor][type];
                item.id = Math.random() * 1000 + vidx + tidx;
                item.vendor = vendor;
                item.deviceType = type;
                roleData.push(item);
            });
        });
        // console.log(roleData);
        return roleData;
    };

    ctx._formatRoleGridToMapping = function (data) {
        const roleDataMapping = {};
        data.forEach((item) => {
            if (!roleDataMapping[item.vendor]) {
                roleDataMapping[item.vendor] = {};
            }
            if (!roleDataMapping[item.vendor][item.deviceType]) {
                roleDataMapping[item.vendor][item.deviceType] = {};
            }
            roleDataMapping[item.vendor][item.deviceType].createMissing = item.create;
            if (item.create) {
                roleDataMapping[item.vendor][item.deviceType].netBoxId = undefined;
                roleDataMapping[item.vendor][item.deviceType].netBoxName = item.netBoxName;
            } else {
                roleDataMapping[item.vendor][item.deviceType].netBoxId = item.netBoxId;
            }
        });
        return roleDataMapping;
    };

    let _validateRowData = function (data, item, idx) {
        if (!item) {
            return;
        }
        if (item.create && !item.netBoxName) {
            return false;
        }
        const refVendor = item.vendor;
        const refType = item.deviceType;
        const itemMatches = data.some((item, currIdx) => {
            if (
                idx !== currIdx &&
                (item.vendor === refVendor || item.vendor === "ALL") &&
                item.deviceType === refType
            ) {
                return true;
            }
            return false;
        });
        if (itemMatches) {
            ctx._isRoleDataValid = false;
            item.isValid = false;
        } else {
            item.isValid = true;
        }
        return item.isValid;
    };

    let _validateGridData = function (data) {
        const invalidRows = [];
        data.forEach((item, idx) => {
            if (!_validateRowData(data, item, idx)) {
                ctx._slickRolesTable &&
                    ctx._slickRolesTable.getCellNode(idx, 0) &&
                    ctx._slickRolesTable
                        .getCellNode(idx, 0)
                        .closest(".slick-row")
                        .addClass("invalid");
                invalidRows.push(idx);
            } else {
                ctx._slickRolesTable &&
                    ctx._slickRolesTable.getCellNode(idx, 0) &&
                    ctx._slickRolesTable
                        .getCellNode(idx, 0)
                        .closest(".slick-row")
                        .removeClass("invalid");
            }
        });
        ctx._isRoleDataValid = !invalidRows.length;
        return ctx._isRoleDataValid;
    };

    ctx._validateRoleData = function () {
        if (!ctx._slickRolesDataView) {
            return true;
        }
        _validateGridData(ctx._slickRolesDataView.getItems());
        return ctx._isRoleDataValid;
    };

    ctx._setRoleData = function () {
        const roleData = {};
        const data = ctx._slickRolesDataView.getItems();
        roleData.mapping = ctx._formatRoleGridToMapping(data);
        roleData.createUnmapped = ctx._drCreateUnmappedCheckbox.getValue();
        // console.log(roleData);
        ctx._setRoleDataToEty(roleData);
        ctx.emit("ValueChange");
        return true;
    };

    ctx._setRoleDataToEty = function (data) {
        const roleData = ctx.getRoleData() || {};
        roleData.createUnmapped = data.createUnmapped;
        roleData.mapping = data.mapping;
        const dataSyncMapping = ctx._dataSyncConfigEntity.getDataSyncMappings() || {};
        _.set(dataSyncMapping, "modelMapping.deviceRoles", roleData);
        ctx._dataSyncConfigEntity.setDataSyncMappings(dataSyncMapping);
    };

    ctx._onAddNewRole = function () {
        // console.log("add role");
        const newRow = ctx._getRoleRow();
        const data = ctx._slickRolesDataView.getItems();
        data.push(newRow);
        ctx._resetRoleGrid(data);
        _validateGridData(data);
        ctx._setRoleData();
    };

    ctx._deleteRole = function (id) {
        const deleteMessage = `Are you sure you want to delete the "Device Role Mapping"?`;
        return ctx
            ._deleteConfirmation(deleteMessage)
            .then(() => {
                ctx._slickRolesDataView.deleteItem(id);
                const data = ctx._slickRolesDataView.getItems();
                ctx._resetRoleGridView(data);
                _validateGridData(data);
                ctx._setRoleData();
            })
            .catch((error) => error && ctx._showError(error));
    };

    ctx._onRoleCellChangeAction = function (/*el, args*/) {
        const data = ctx._slickRolesDataView.getItems();
        _validateGridData(data);
        ctx._setRoleData();
    }.bind(ctx);
}

module.exports = createWithContext;
